export const appsBusinessAccountsDatatable = "/apps/business/accounts_datatable";
